export default __webpack_public_path__ + "static/media/d984cf3bf364e651c310748597fbdbb71581594386502.6bc33cf6.webp";